import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import SidePanelPlaceholder from '@/modules/DetailedCar/DetailedCarPlaceholder/components/SidePanelPlaceholder';
import { media } from '@/utils/mixin';

import MobileNavigationPlaceholder from './components/MobileNavigationPlaceholder';
import PreviewSpecificationPlaceholder from './components/PreviewSpecificationPlaceholder';
import GalleryPlaceholder from './components/GalleryPlaceholder';
import TitlePlaceholder from './components/TitlePlaceholder';

function MainPlaceholder() {
  return (
    <Component>
      <MobileNavigationPlaceholder />
      <TitlePlaceholder />
      <GalleryPlaceholder />
      <StyledSidePanelPlaceholder />
      <InfoPlaceholder />
      <PreviewSpecificationPlaceholder />
    </Component>
  );
}

export default MainPlaceholder;

const Component = styled.div`
  overflow: hidden;
  flex: 1;
`;

const InfoPlaceholder = styled.div`
  margin-top: 35px;
  height: 18px;
  max-width: 650px;
  border-radius: 8px;
  ${placeholderAnimationCss}
`;

const StyledSidePanelPlaceholder = styled(SidePanelPlaceholder)`
  display: none;

  ${media.tablet(
    css`
      display: block;
    `
  )}
`;
